import type { CategoryLevel } from '../enums/CategoryLevel'
import type { CategoryTranslationEntity } from './CategoryTranslationEntity'
import type { BranchEntity } from '@/features/branch/domain/entities/BranchEntity'
import type { CategoryMiniEntity } from './CategoryMiniEntity'
import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'

export class CreateUpdateCategoryEntity {
  imageData?: FileUploadEntity | null
  imageUrl?: string
  id?: number
  enabled?: boolean
  level?: CategoryLevel
  parentCategory?: CategoryMiniEntity | null
  translations?: Array<CategoryTranslationEntity>
  branch?: BranchEntity
  isSensitive?: boolean
  startTime?: string | null
  endTime?: string | null
  isServiceCategory?: boolean
  zohoBooksCostAccountId?: string | null
  zohoBooksSalesAccountId?: string | null
}
